import { FillInputByLabelInstruction } from '../FillInputByLabelInstruction'

export class CorporateRutInstruction extends FillInputByLabelInstruction {
  constructor ({ label, waitForNoLoaders, value }) {
    super({
      name: 'CorporateRut',
      label,
      waitForNoLoaders,
      value

    })
  }

  setDefaultValue (params) {
    this.value = params.billingInformation.corporateRut
  }
}
